module.exports = __webpack_public_path__ + "static/img/17.798c851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/17.jpg
// module id = 9zhb
// module chunks = 0